/**
 * Utility functions for subscription status handling
 */

export const SUBSCRIPTION_BLOCKS_ONE_TIME_MESSAGE =
  "One-time purchases are not available while you have an active subscription. Use Download instead.";

/**
 * Check if a user has an active subscription
 * Handles both legacy boolean format and new object format
 * @param {boolean|string|object} subscription - The subscription data from auth
 * @returns {boolean} - True if user has active subscription
 */
export const hasActiveSubscription = (subscription) => {
  // Handle legacy boolean/string formats
  if (subscription === true || subscription === "true") {
    return true;
  }
  
  // Handle new object format
  if (subscription && typeof subscription === 'object') {
    return subscription.subscriptionStatus === true;
  }
  
  // Default to false for any other cases (including false, "false", null, undefined)
  return false;
};

/**
 * Get subscription validity date if available
 * @param {boolean|string|object} subscription - The subscription data from auth
 * @returns {string|null} - Validity date string or null
 */
export const getSubscriptionValidityDate = (subscription) => {
  if (subscription && typeof subscription === 'object') {
    return subscription.validityDate || null;
  }
  return null;
};

/**
 * Check if subscription is expired (if validity date is provided)
 * @param {boolean|string|object} subscription - The subscription data from auth
 * @returns {boolean} - True if subscription is expired
 */
export const isSubscriptionExpired = (subscription) => {
  const validityDate = getSubscriptionValidityDate(subscription);
  if (!validityDate) {
    return false; // No validity date means no expiration
  }
  
  return new Date(validityDate) < new Date();
};